module.exports = __webpack_public_path__ + "img/mission-c.e539d8df.svg";